import Vue from "vue";
import Router from "vue-router";
import StaticPage from "@/views/staticPage/index.vue"; // 假设有一个About组件

Vue.use(Router);

export default new Router({
  mode: "hash",
  routes: [
    {
      path: "/staticPage",
      name: "staticPage",
      component: StaticPage,
    },
  ],
});
